import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { SwissInsuranceType } from "@/types/insurance";

export const useInsuranceTypes = () => {
  return useQuery({
    queryKey: ['insurance-types'],
    queryFn: async (): Promise<SwissInsuranceType[]> => {
      const { data, error } = await supabase
        .from('swiss_insurance_types')
        .select('*')
        .order('category', { ascending: true })
        .order('name_german', { ascending: true });

      if (error) {
        throw error;
      }

      return (data || []) as SwissInsuranceType[];
    }
  });
};